import React, { useEffect , useState } from 'react';
import {
  Card,
  CardBody, 
  Button,
  Input,
  Form,
  FormGroup,
  Container
} from 'reactstrap';


import { useForm } from "react-hook-form"
import { FormInput , FormError , RenderErrors } from '../../../components/MyForm'
import { email_verification_code_verify_action } from '../actions'

const EmailVerification = ({
      email,

      verification_code,
      set_verification_code,

      verified_code,
      set_verified_code,

      next_step ,
      prev_step
}) => {


  const {
    register,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm({
      mode: 'onChange',
      defaultValues: {
          'verification_code': verification_code,
          'email' : email
      }
  });


    const [ submitDisabled , setSubmitDisabled ] = useState(false)
    const [ servererror, setServerError] = useState({})


  useEffect(() => {
     
  },[]);


  return (

  <Container className="mt-3 d-flex justify-content-center align-items-center">
    
    <Card className='w-50'>
  
     <CardBody>

     <Form onSubmit={ handleSubmit(async (data) => { 
        try {

           if (verified_code) {
               next_step()
           } else {
               console.log('email verification code handle submit')
               console.log(data)
               const response = await email_verification_code_verify_action(data['email'], data['verification_code'])
               console.log('response after submitting verification code:')
               console.log(response.data)
               set_verification_code(data['verification_code'])
               set_verified_code(true)
               next_step()
           }

        } catch (error) {
            console.log('email vrfication code verify error!')
            console.log(error)
            if (error.response) {
                setServerError((old)=> ({...old, ...error.response.data}))
            }
        }
    })}>


    <FormGroup>
       <FormInput
        register={register}
        name='email'
        id='email'
        label='Email'
        type='text'
        disabled
       />

    </FormGroup>

     <div className='fst-italic fs-7'>
       <p>
        An <span className='fw-bold'>8-digit code</span> has been sent to your email (expires in 30 minutes).
       </p>
      
     </div>


    <FormGroup>
       <FormInput
        register={register}
        name='verification_code'
        id='verification_code'
        label='Verification Code'
        placeholder='enter your email verification code'
        type='text'
        validation={{required: 'Verification code is empty!'}}
        OnChangeCustom ={(e)=> setServerError({})}
        invalid={errors.verification_code}
        disabled={verified_code}
       />

        { 
              errors.verification_code && 
              <FormError message={errors.verification_code.message}/>
        }
    
    </FormGroup>

      { servererror && <RenderErrors errors={servererror}/> }


      <div className="d-flex align-items-center justify-content-center">
        <Button 
           color='primary' 
           onClick={prev_step}
         >
         Go Back
        </Button>

        &nbsp;&nbsp;

        <Button 
          color='primary'
          type="submit" 
        >
         Next
        </Button>
      </div>

    </Form>

       </CardBody>
      </Card>
     </Container>
  )
}

export default EmailVerification;
